'use client';

import React from 'react';

import CompactReferralsList from './CompactReferralsList';

const CompactInboundReferrals: React.FC = () => (
  <CompactReferralsList
    direction="inbound"
    title="Inbound Referrals"
    testIdPrefix="compact-inbound-referrals"
  />
);

export default CompactInboundReferrals;
